// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Snackbar,
//   Alert as MuiAlert,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from '@mui/material';
// import { VideoLibrary as VideoLibraryIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { useAuth } from './auth/AuthContext';
// import api from '../utils/api';

// const categories = [
//   { label: 'General Learning Videos', value: 'general' },
//   { label: 'Creative Videos', value: 'creative' },
//   { label: 'Innovation Videos', value: 'innovation' },
//   { label: 'Learning Cartoons', value: 'cartoons' },
//   { label: 'Play group Learning', value: 'playgroup' },
// ];

// const AdminVideoUpload = () => {
//   const navigate = useNavigate();
//   const { isAdminAuthenticated } = useAuth();

//   const [title, setTitle] = useState('');
//   const [description, setDescription] = useState('');
//   const [category, setCategory] = useState('general');
//   const [videoFile, setVideoFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       if (!selectedFile.type.startsWith('video/')) {
//         setSnackbar({
//           open: true,
//           message: 'Invalid file type. Please select a video file.',
//           severity: 'error',
//         });
//         return;
//       }
//       setVideoFile({ name: selectedFile.name, file: selectedFile });
//       setErrors({ ...errors, videoFile: '' });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!title.trim()) newErrors.title = 'Title is required';
//     if (!videoFile) newErrors.videoFile = 'Please select a video file';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleUpload = async () => {
//     if (!isAdminAuthenticated) {
//       setSnackbar({
//         open: true,
//         message: 'Please login as admin first',
//         severity: 'error',
//       });
//       return;
//     }

//     if (!validateForm()) {
//       setSnackbar({
//         open: true,
//         message: 'Please fill in all required fields',
//         severity: 'error',
//       });
//       return;
//     }

//     setLoading(true);
//     const formData = new FormData();
//     formData.append('title', title);
//     formData.append('description', description);
//     formData.append('category', category);
//     formData.append('video', videoFile.file);

//     try {
//       await api.post('/api/admin/videos/category', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       setSnackbar({
//         open: true,
//         message: 'Video uploaded successfully!',
//         severity: 'success',
//       });
//       setTimeout(() => navigate(-1), 2000);
//     } catch (error) {
//       console.error('Upload error:', error);
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || 'Failed to upload video. Please try again.',
//         severity: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   return (
//     <Container maxWidth="sm" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 4, textAlign: 'center' }}>
//           Upload Category Video
//         </Typography>
//         <Paper sx={{ p: 3, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.1 }}>
//             <FormControl fullWidth sx={{ mb: 2, bgcolor: '#fff' }}>
//               <InputLabel>Category</InputLabel>
//               <Select value={category} onChange={(e) => setCategory(e.target.value)} label="Category">
//                 {categories.map((cat) => (
//                   <MenuItem key={cat.value} value={cat.value}>{cat.label}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.2 }}>
//             <TextField
//               fullWidth
//               label="Title *"
//               value={title}
//               onChange={(e) => { setTitle(e.target.value); setErrors({ ...errors, title: '' }); }}
//               error={!!errors.title}
//               helperText={errors.title}
//               sx={{ mb: 2, bgcolor: '#fff' }}
//             />
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.3 }}>
//             <TextField
//               fullWidth
//               label="Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               multiline
//               rows={4}
//               sx={{ mb: 2, bgcolor: '#fff' }}
//             />
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.4 }}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<VideoLibraryIcon />}
//               sx={{
//                 bgcolor: '#6200ee',
//                 '&:hover': { bgcolor: '#7f39fb' },
//                 borderRadius: 2,
//                 mb: 2,
//                 py: 1.5,
//                 fontSize: '1rem',
//                 textTransform: 'none',
//               }}
//             >
//               Select Video
//               <input type="file" hidden accept="video/*" onChange={handleFileChange} />
//             </Button>
//             {errors.videoFile && <Typography color="error" variant="caption">{errors.videoFile}</Typography>}
//           </motion.div>
//           {videoFile && (
//             <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3, delay: 0.5 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#fff', borderRadius: 2, p: 2, mb: 2, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
//                 <VideoLibraryIcon sx={{ color: '#6200ee', mr: 1 }} />
//                 <Typography variant="body2" sx={{ color: '#2c3e50', flex: 1 }}>{videoFile.name}</Typography>
//               </Box>
//             </motion.div>
//           )}
//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: 0.6 }}>
//             <Button
//               variant="contained"
//               startIcon={loading ? null : <CloudUploadIcon />}
//               onClick={handleUpload}
//               disabled={loading}
//               fullWidth
//               sx={{
//                 bgcolor: '#9C27B0',
//                 '&:hover': { bgcolor: '#aa00cc' },
//                 borderRadius: 2,
//                 py: 1.5,
//                 fontSize: '1.1rem',
//                 fontWeight: 'bold',
//                 mt: 2,
//                 opacity: loading ? 0.6 : 1,
//               }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Upload Video'}
//             </Button>
//           </motion.div>
//         </Paper>
//       </motion.div>
//       <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
//         <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </MuiAlert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default AdminVideoUpload;

// AdminVideoUpload.js - UPDATED WITH BETTER AUTH HANDLING
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Snackbar,
  Alert as MuiAlert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import {
  VideoLibrary as VideoLibraryIcon,
  CloudUpload as CloudUploadIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import { useAuth } from "./auth/AuthContext";
import api from "../utils/api";

const categories = [
  { label: "General Learning Videos", value: "general" },
  { label: "Creative Videos", value: "creative" },
  { label: "Innovation Videos", value: "innovation" },
  { label: "Learning Cartoons", value: "cartoons" },
  { label: "Play group Learning", value: "playgroup" },
];

const AdminVideoUpload = () => {
  const navigate = useNavigate();
  const { isAdminAuthenticated, adminToken, checkAuthState } = useAuth();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("general");
  const [videoFile, setVideoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Check authentication on component mount
  useEffect(() => {
    checkAuthState();
    console.log("Video Upload - Auth State:", {
      isAdminAuthenticated,
      adminToken: adminToken ? "Present" : "Missing",
    });
  }, [checkAuthState, isAdminAuthenticated, adminToken]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("video/")) {
        setSnackbar({
          open: true,
          message: "Invalid file type. Please select a video file.",
          severity: "error",
        });
        return;
      }

      if (selectedFile.size > 100 * 1024 * 1024) {
        setSnackbar({
          open: true,
          message:
            "File size exceeds 100MB limit. Please select a smaller video.",
          severity: "error",
        });
        return;
      }

      setVideoFile(selectedFile);
      setErrors({ ...errors, videoFile: "" });
      setUploadProgress(0);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    if (!videoFile) newErrors.videoFile = "Please select a video file";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpload = async () => {
    // Double-check authentication
    if (!isAdminAuthenticated || !adminToken) {
      setSnackbar({
        open: true,
        message: "Please login as admin first. Authentication required.",
        severity: "error",
      });
      // Redirect to login
      setTimeout(() => navigate("/admin-login"), 2000);
      return;
    }

    if (!validateForm()) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields",
        severity: "error",
      });
      return;
    }

    setLoading(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("category", category);
    formData.append("video", videoFile);

    console.log(
      "Starting upload with token:",
      adminToken ? "Present" : "Missing"
    );

    try {
      const response = await api.post("/api/admin/videos/category", formData, {
        headers: {
          "x-auth-token": adminToken,
          "user-type": "admin",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          }
        },
      });

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: "Video uploaded successfully!",
          severity: "success",
        });
        // Reset form
        setTitle("");
        setDescription("");
        setCategory("general");
        setVideoFile(null);
        setUploadProgress(0);
        setTimeout(() => navigate(-1), 2000);
      }
    } catch (error) {
      console.error("Upload error:", error);
      let errorMessage = "Failed to upload video. Please try again.";

      if (error.response?.status === 401) {
        errorMessage = "Authentication failed. Please login again.";
        localStorage.removeItem("adminToken");
        setTimeout(() => navigate("/admin-login"), 2000);
      } else if (error.code === "ECONNABORTED") {
        errorMessage = "Upload timeout. Please try again with a smaller file.";
      } else if (error.response?.status === 413) {
        errorMessage = "File too large. Maximum size is 100MB.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Show loading while checking auth
  if (!isAdminAuthenticated) {
    return (
      <Container
        maxWidth="sm"
        sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
      >
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="h5" color="error" gutterBottom>
            Authentication Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Please login as admin to upload videos.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/admin-login")}
            sx={{ mt: 2 }}
          >
            Go to Login
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="sm"
      sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#2c3e50",
            mb: 4,
            textAlign: "center",
          }}
        >
          Upload Category Video
        </Typography>

        <Paper
          sx={{
            p: 3,
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          }}
        >
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Category *</InputLabel>
            <Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              label="Category *"
            >
              {categories.map((cat) => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Title *"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setErrors({ ...errors, title: "" });
            }}
            error={!!errors.title}
            helperText={errors.title}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={4}
            sx={{ mb: 2 }}
          />

          <Button
            variant="outlined"
            component="label"
            startIcon={<VideoLibraryIcon />}
            sx={{ mb: 2 }}
            fullWidth
          >
            Select Video (Max 100MB) *
            <input
              type="file"
              hidden
              accept="video/*"
              onChange={handleFileChange}
            />
          </Button>

          {errors.videoFile && (
            <Typography
              color="error"
              variant="caption"
              sx={{ display: "block", mb: 2 }}
            >
              {errors.videoFile}
            </Typography>
          )}

          {videoFile && (
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  bgcolor: "#f5f5f5",
                  borderRadius: 1,
                  mb: 1,
                }}
              >
                <VideoLibraryIcon sx={{ color: "#6200ee", mr: 1 }} />
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" sx={{ color: "#2c3e50" }}>
                    {videoFile.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666" }}>
                    Size: {(videoFile.size / 1024 / 1024).toFixed(2)} MB
                  </Typography>
                </Box>
              </Box>

              {loading && uploadProgress > 0 && (
                <Box sx={{ width: "100%", mt: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={uploadProgress}
                    sx={{ height: 8, borderRadius: 4 }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ display: "block", textAlign: "center", mt: 1 }}
                  >
                    Uploading: {uploadProgress}%
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          <Button
            variant="contained"
            startIcon={loading ? null : <CloudUploadIcon />}
            onClick={handleUpload}
            disabled={loading}
            fullWidth
            sx={{
              bgcolor: "#9C27B0",
              "&:hover": { bgcolor: "#aa00cc" },
              borderRadius: 2,
              py: 1.5,
              fontSize: "1.1rem",
              fontWeight: "bold",
              mt: 2,
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                Uploading...
              </Box>
            ) : (
              "Upload Video"
            )}
          </Button>
        </Paper>
      </motion.div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};

export default AdminVideoUpload;
